import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles(theme => ({
  iframe: {
    width: '100%',
    minHeight: 'auto',
    border: 'none'
  }
}))
